import { ErrorType } from '@/modules/models';

export const MESSAGE_LIMIT = 500;

export const RefreshErrorTypes = [
  ErrorType.EmptyChatId,
  ErrorType.ConnectionFailure,
  ErrorType.NotInitialized,
  ErrorType.AddToCartFailure,
];

export const IP_INFO_TOKEN = '38da653612df6d';
